import { IApplicationState } from '../types/redux';

export const selectUserAgreement = (state: IApplicationState) => state.user.isMarketingAgreement;
